import React from 'react';
import { CallRingSettingsPanel } from '@/components/calls/CallRingSettingsPanel';

const CallRingSettings = () => {
  return (
    <div className="container mx-auto py-6 max-w-4xl">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Call Ring Settings</h1>
        <p className="text-muted-foreground mt-2">
          Configure the Ring All system for voice calls
        </p>
      </div>
      <CallRingSettingsPanel />
    </div>
  );
};

export default CallRingSettings;
